import { render, staticRenderFns } from "./ManageEvent.vue?vue&type=template&id=f8d55950&scoped=true"
import script from "./ManageEvent.vue?vue&type=script&lang=js"
export * from "./ManageEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d55950",
  null
  
)

export default component.exports